var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vehicle-status-panel',{attrs:{"title":"海康车辆状态查询","source":"hik","use-hik-api":true}})}
var staticRenderFns = []

export { render, staticRenderFns }